import { render, staticRenderFns } from "./SessionsPerCustomerTable.vue?vue&type=template&id=ef607a6c&scoped=true"
import script from "./SessionsPerCustomerTable.vue?vue&type=script&lang=ts"
export * from "./SessionsPerCustomerTable.vue?vue&type=script&lang=ts"
import style0 from "./SessionsPerCustomerTable.vue?vue&type=style&index=0&id=ef607a6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef607a6c",
  null
  
)

export default component.exports